import LoginModal from "@/components/modals/LoginModal";
import UsersBrowserTable from "@/components/user-interfaces/UsersBrowserTable";
import { SessionContext } from "@/context/SessionContext";
import { Card, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import React, {
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { Link } from "react-router-dom";

const UsersAdminBrowser: React.FC = () => {
    const [showLoginModal, setShowLoginModal] = useState<boolean>(false);
    const [userHasAccess, setUserHasAccess] = useState<boolean>(false);

    const theme = useMantineTheme();
    const session = useContext(SessionContext);

    const dashboardRef = useRef<HTMLDivElement>(null);

    if (!session) {
        return null;
    }

    useEffect(() => {
        if (session.user?.roles.includes("ConductionAdmin")) {
            setUserHasAccess(true);
            setShowLoginModal(false);
        } else {
            setUserHasAccess(false);
            if (session.user == null) {
                setShowLoginModal(true);
            }
        }
    }, [session.user]);

    if (!userHasAccess) {
        return (
            <>
                <LoginModal showModal={showLoginModal} setShowModal={setShowLoginModal} />
                <Card p={20}>
                    <IconLock size={48} color={theme.colors.red[6]} />
                    <Text>You do not have permission to access this page.</Text>
                    <Text>Please log into an account with access or <Link to="/">click here to navigate away</Link>.</Text>
                </Card>
            </>
        );
    }

    return (
        <Stack ref={dashboardRef} align="center" justify="center" w="100%" pt="50px">
            <UsersBrowserTable />
        </Stack>
    );
};

export default UsersAdminBrowser;
